import { render } from "./App.vue?vue&type=template&id=5fdcb928"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5fdcb928&lang=css"
import "./assets/css/global.css?vue&type=style&index=1&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__